import * as Plottable from 'plottable'

export default (ctx, inject) => {
  inject('plottable', Plottable)
}
